import { z } from "zod"

const subscriptionSchema = z.object({
  full_name: z.string().trim().nonempty("Full name is required!"),
  email: z.string().trim().nonempty("Email is required!").email("Invalid email address!"),
}).required()

const registrationSchema = z.object({
  name: z.string().trim().nonempty("Name is required!"),
  email: z.string().trim().nonempty("Email is required!").email("Invalid email address!"),
  phone: z.string().trim().nonempty("Phone is required!"),
  password: z.string().trim().nonempty("Password is required!"),
  password_confirm: z.string().trim().nonempty("Confirmation password is required!"),
}).required()

const loginSchema = z.object({
  email: z.string().trim().nonempty("Email is required!").email("Invalid email address!"),
  password: z.string().trim().nonempty("Password is required!"),
}).required()

const forgotPassSchema = z.object({
  email: z.string().trim().nonempty("Email is required!").email("Invalid email address!"),
}).required()

const resetPassSchema1 = z.object({
  token: z.string().trim().nonempty("Token is required!"),
  email: z.string().trim().nonempty("Email is required!").email("Invalid email address!"),
  password: z.string().trim().nonempty("Password is required!"),
  password_confirm: z.string().trim().nonempty("Confirmation password is required!"),
}).required()

const resetPassSchema2 = z.object({
  password_current: z.string().trim().nonempty("Old password is required!"),
  password: z.string().trim().nonempty("New password is required!"),
  password_confirm: z.string().trim().nonempty("Confirmation password is required!"),
}).required()

const verificationSchema = z.object({
  code: z.string().trim().nonempty("Verification code is required!"),
})

const resSchema = z.object({
  name: z.string().trim().nonempty("Name is required!"),
  pax: z.number(),
  phone: z.string().trim().nonempty("Phone is required!"),
  email: z.string().trim().nonempty("Email is required!"),
  date: z.string().trim().nonempty("Date is required!"),
  month: z.string().trim().nonempty("Month is required!"),
  year: z.string().trim().nonempty("Year is required!"),
  time: z.string().trim().nonempty("Time is required!"),
  message: z.string().trim().nonempty("Message is required!"),
})

const userDetailSchema = z.object({
  id: z.string().trim().nonempty("Id is required!"),
  name: z.string().trim().nonempty("Name is required!"),
  email: z.string().trim().nonempty("Email is required!"),
  phone: z.string().trim().nonempty("Phone is required!"),
  address: z.string().trim().nonempty("Address is required!"),
  ro_destination_id: z.number(),
})

const productSchema = z.object({
  product_id: z.string().trim().nonempty("Product id is required!"),
  qty: z.string().trim().nonempty("Quantity amount is required!"),
  is_checked: z.number().optional(), // default to 1 for checked
})

const faqSchema = z.object({
  first_name: z.string().trim().nonempty("First name is required!"),
  last_name: z.string().trim().nonempty("Last name is required!"),
  email: z.string().trim().nonempty("Email is required!"),
  subject: z.string().trim().nonempty("Subject is required!"),
  message: z.string().trim().nonempty("Message is required!"),
})

export {
  subscriptionSchema,
  registrationSchema,
  loginSchema,
  forgotPassSchema,
  resetPassSchema1,
  resetPassSchema2,
  verificationSchema,
  resSchema,
  userDetailSchema,
  productSchema,
  faqSchema
}